import { WHITE_LABEL_CONFIG } from "@/whiteLable";
import { App_Url_New } from "../common/static";
import { NavChild, NavItemType } from "../types/header";
import { B2C_FEATURE_FLAGS } from "./FeatureFlags.config";

export { B2C_FEATURE_FLAGS } from "./FeatureFlags.config";

export type B2CProductKey = "motor" | "home" | "travel" | "health" | "life";

const PRODUCT_HIDE_FLAGS: Record<B2CProductKey, boolean> = {
  motor: B2C_FEATURE_FLAGS.isCarHide,
  home: B2C_FEATURE_FLAGS.isHomeHide,
  travel: B2C_FEATURE_FLAGS.isTravelHide,
  health: B2C_FEATURE_FLAGS.isHealthHide,
  life: B2C_FEATURE_FLAGS.isLifeHide,
};

export const isB2CProductVisible = (product: B2CProductKey) => !PRODUCT_HIDE_FLAGS[product];

// Life-focused content: swaps the whole product menu for life sub-products.
// Only applies while the Life product itself is visible.
export const isLifeHomeContentEnabled = () =>
  isB2CProductVisible("life") && B2C_FEATURE_FLAGS.isLifeHomeContent;

export const PRODUCT_NAV_LABEL = isLifeHomeContentEnabled() ? "Products" : "Insurance";

const LIFE_HOME_NAV_CHILDREN: NavChild[] = [
  { label: "Term Life", path: App_Url_New.D2CPageUrl.insurance.lifeGetQuote },
  // No journey for these two yet, so they stay on the home page.
  { label: "Market Linked Products", path: App_Url_New.D2CPageUrl.home },
  { label: "Income Products", path: App_Url_New.D2CPageUrl.home },
];

const STANDARD_NAV_CHILDREN: NavChild[] = [
  ...(isB2CProductVisible("motor")
    ? [{ label: "Car", path: App_Url_New.D2CPageUrl.insurance.carGetQuote }]
    : []),
  ...(isB2CProductVisible("home")
    ? [{ label: "Home", path: App_Url_New.D2CPageUrl.insurance.home }]
    : []),
  ...(isB2CProductVisible("travel")
    ? [{ label: "Travel", path: App_Url_New.D2CPageUrl.insurance.travelGetQuote }]
    : []),
  ...(isB2CProductVisible("health")
    ? [{ label: "Health", path: App_Url_New.D2CPageUrl.insurance.healthGetQuote }]
    : []),
  ...(isB2CProductVisible("life")
    ? [{ label: "Life", path: App_Url_New.D2CPageUrl.insurance.lifeGetQuote }]
    : []),
];

const PRODUCT_NAV_CHILDREN = isLifeHomeContentEnabled()
  ? LIFE_HOME_NAV_CHILDREN
  : STANDARD_NAV_CHILDREN;

// Use this instead of looking the menu up by label — the label itself is dynamic.
export const getProductNavChildren = () => PRODUCT_NAV_CHILDREN;

const SERVICE_NAV_CHILDREN: NavChild[] = [
  { label: "Claims", path: App_Url_New.CommonPageUrl.services.claims },

  ...(isLifeHomeContentEnabled()
    ? []
    : [
        {
          label: "Roadside Assistance",
          path: App_Url_New.CommonPageUrl.services.roadsideAssistance,
        },
      ]),
  { label: "Complaints", path: App_Url_New.CommonPageUrl.services.complaints },
];

export const getServiceNavChildren = () => SERVICE_NAV_CHILDREN;

export const HOMEPAGE_CONTENT = (() => {
  const { lifeContent, ...baseHomepage } = WHITE_LABEL_CONFIG.homepage;

  if (!isLifeHomeContentEnabled() || !lifeContent) {
    return baseHomepage;
  }

  return Object.entries(lifeContent).reduce(
    (merged, [section, overrides]) => ({
      ...merged,
      [section]: { ...merged[section], ...(overrides as object) },
    }),
    baseHomepage
  );
})();

export const HEADER_CONFIG: {
  brand: {
    link: string;
  };
  phone: {
    label: string;
    value: string;
  };
  navigation: NavItemType[];
} = {
  brand: {
    link: App_Url_New.D2CPageUrl.home,
  },

  phone: {
    label: WHITE_LABEL_CONFIG.contact.phoneLabel,
    value: WHITE_LABEL_CONFIG.contact.phoneValue,
  },

  navigation: [
    {
      label: PRODUCT_NAV_LABEL,
      children: PRODUCT_NAV_CHILDREN,
    },
    {
      label: "Services",
      children: SERVICE_NAV_CHILDREN,
    },
    {
      label: "About Us",
      path: App_Url_New.CommonPageUrl.aboutUs,
    },
  ],
};

// Secured nav items (Dashboard, Quotes, Policies, etc.) are no longer hardcoded here — they're
// derived at runtime from the logged-in user's backend-provided modules.
// See: src/shared/config/secureNavigation.config.tsx -> getSecureNavItemsFromModules
